import { Stack } from 'expo-router';

export default function DuelsLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
